import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {PageEnum, CallsWizardErrorsEnum} from 'app/Components/Block/AbroadCallsTroubleshootingWizardBlock/constants/constans';

const initialState = {
  epiBlockData: {},
  currentStep: '',
  errorType: '',
  selectedSubscriber: '',
};

const AbroadCallsTroubleshootingWizardSlice = createSlice({
  name: 'AbroadCallsTroubleshootingWizard',
  initialState: initialState,
  reducers: {
    resetBlock: () => initialState,
    initialData: (state, action) => {
      state.epiBlockData = getEpiContentObject(action.payload);
      // state.currentStep = PageEnum.SUBSCRIBERS;
      //for mock purpose only
      state.currentStep = PageEnum.ERROR;
      state.errorType = CallsWizardErrorsEnum.ABROAD_PACKAGE_DOES_NOT_FIT_TO_DESTINATION;
    },
    reportDWH: (state, action) => {},
    setSelectedSubscriber: (state, action) => {
      state.selectedSubscriber = action.payload;
    },
    setErrorType: (state, action) => {
      state.errorType = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
  },
  extraReducers: {},
});

export const {resetBlock, initialData, reportDWH, setSelectedSubscriber, setErrorType, setCurrentStep} =
  AbroadCallsTroubleshootingWizardSlice.actions;

export default AbroadCallsTroubleshootingWizardSlice.reducer;
